import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase/client'
import { useUser } from '@/hooks/useAuth'
import type { Notification } from '@/types'

export function useMarkNotificationRead() {
  const user = useUser()
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (notificationId: string) => {
      const { error } = await supabase
        .from('notifications')
        .update({ read_at: new Date().toISOString() })
        .eq('id', notificationId)
        .eq('recipient_user_id', user!.id)
      if (error) throw error
    },

    onMutate: async (notificationId) => {
      await qc.cancelQueries({ queryKey: ['notifications', user?.id] })
      const prev = qc.getQueryData<Notification[]>(['notifications', user?.id])
      qc.setQueryData<Notification[]>(['notifications', user?.id], (old) =>
        (old ?? []).map((n) =>
          n.id === notificationId ? { ...n, read_at: new Date().toISOString() } : n,
        ),
      )
      return { prev }
    },

    onError: (_err, _id, ctx) => {
      if (ctx?.prev) qc.setQueryData(['notifications', user?.id], ctx.prev)
    },

    onSettled: () => {
      qc.invalidateQueries({ queryKey: ['notifications', user?.id] })
    },
  })
}
